export function openPrintPreviewInNewTab(opts: { title: string; html: string; css: string }) {
  const fullHtml = `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${escapeHtml(opts.title)}</title>
    <style>
      ${opts.css}
      @page { size: A4; margin: 12mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
      /* Safety: always clip photo box so photo never overflows, regardless of saved CSS version */
      .ms-photo-box { overflow: hidden; }
      .ms-student-photo { width: 130px; height: 155px; max-width: 130px; max-height: 155px; object-fit: cover; display: block; }
      .ms-photo-box .ms-student-photo { width: 100%; height: 100%; max-width: unset; max-height: unset; }
    </style>
  </head>
  <body>
    ${opts.html}
  </body>
</html>`;

  const blob = new Blob([fullHtml], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (!win) {
    URL.revokeObjectURL(url);
    return;
  }
  // Revoke blob URL after tab has loaded the content
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

function escapeHtml(text: string) {
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

